export const baseSize = 16;

export const breakpoints = ['425px', '768px', '1200px', '1460px'];

export const baseColors = {
  black: '#000',
  brand: [],
  grey: [],
  primary: [],
  secondary: [],
  supplementary: [],
  white: '#fff',
};

export const colors = {
  ...baseColors,
  background: baseColors.white,
  danger: '',
  disabled: '',
  heading: '',
  info: '',
  primary: '',
  secondary: '',
  success: '',
  tertiary: '',
  text: '',
  warning: '',
};

export const fonts = {
  body: '',
  button: '',
  heading: 'inherit',
  monospace: '',
  sans: '',
};

export const fontSizes = [
  '0.75rem', // '80%',
  '0.875rem',
  '1rem',
  '1.25rem',
  '1.5rem',
  '1.75rem',
  '2rem',
  '2.5rem',
  '3.5rem',
  '4.5rem',
  '5.5rem',
  '6rem',
];

export const fontWeights = [];

export const lineHeights = ['1.1', '1.125', '1.188', '1.333', '1.4'];

export const mediaQueries = {};

export const radii = ['0', '8', '16', '32'];

export const shadows = {};

export const space = [0, 4, 8, 12, 16, 24, 32, 40, 56, 72].map(
  (px) => `${px ? px / baseSize : 0}rem`
);

export const zIndices = {};
